import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EnvConfigService {
  private _envConfifFilePath: string = "env-config/env-config.json";
  public envConfig: EnvConfig;

  constructor(private http: HttpClient) {}

  public load(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http
        .get(this._envConfifFilePath)
        .pipe(map(this.extractData))
        .subscribe({
          next: (response: EnvConfig) => {
            this.envConfig = response;
            resolve(this.envConfig);
          },
          error: (errorResponse: any) => {
            console.log(`Failed to load configuration ${errorResponse}`);
            reject(errorResponse);
          },
        });
    });
  }

  private extractData(res: Response) {
    return res || {};
  }
}

export function envConfigFactory(service: EnvConfigService): Function {
  return () => service.load();
}

export interface EnvConfig {
  APIBASEURL: string;
  defaultPageSize?: number;
  enableChats?: boolean;
  enableInboxMessages?: boolean;
  enableGlobalSearch?: boolean;
  enableMultiLanguage?: boolean;
  enableNotifications?: boolean;
  enableShortcuts?: boolean;
  enableFullScreen?: boolean;
  defaultProductCategoryAdaptiveUICode?: string;
  aiAssessment?: AiAssessmentConfig;
  editorConfig?: EditorConfig;
}

export interface AiAssessmentConfig {
  enabled?: boolean;
  chatClient?: string;
}

export interface EditorConfig {
  readonly?: boolean;
  toolbar?: boolean;
  toolbarSticky?: boolean;
  toolbarAdaptive?: boolean;
  toolbarButtonSize?: string;

  buttons?: string[];

  height?: number;
  width?: string;
  minHeight?: number;

  theme?: string;
  direction?: string;

  placeholder?: string;
}
